import {
  getSubmitOrderRequest,getApproveSubOrderRequest,requestSuborderStatusReset
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";
import ajax from "../../../api/ajax";  // 导入封装后的axios请求

const state = {
  recreate_id : 0
}

const getters = {
  getRecreateId : state => {
    return state.recreate_id
  }
}

const actions = {
  async getSubmitOrder ({commit}, params) {
    return getSubmitOrderRequest(getUrl(params)).then(response => response)
  },
  async getApproveSubOrder ({commit}, params) {
    return getApproveSubOrderRequest(getUrl(params)).then(response => response)
  },
  async postSuborderStatusResetMethod ({commit},params){
    return requestSuborderStatusReset(params).then(response => response)
  }
};

const mutations = {
  setRecreateId(state,id){
     state.recreate_id = id
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/submitorder/submitorder.js